<template>
  <header
    class="
      tw-flex
      tw-justify-end
      tw-items-center
      tw-px-8
      tw-py-3
      tw-gap-4
      tw-border-0
      tw-border-sf-neutral-lighter-2
      tw-border-solid
      tw-h-[60px]
    "
    :class="{ 'tw-border-b': !empty }"
  >
    <NewRemarkButton
      extra-classes="sf-btn-success"
      :ledger-id="ledgerId"
      :ledger-label="ledgerLabel"
      :owner-type="'Company'"
      :owner-id="ownerId"
      :hide-period-selector="true"
      :selected-tag-ids="
        talkingPointTagId !== undefined ? [talkingPointTagId] : []
      "
    ></NewRemarkButton>
    <SfButtonInverted :disabled="empty" @click="completeMeeting">
      {{
        I18n.t('client_meetings.meeting_preparation.complete_meeting_button')
      }}
    </SfButtonInverted>
    <SfButtonInverted
      v-if="suggestionsEnabled && !showSidebar"
      variant="dark"
      class="tw-min-w-9 tw-h-9"
      data-test-id="open-assistant-suggestions-button"
      @click="toggleSidebar"
    >
      <i class="fa fa-wand-magic-sparkles" />
      <div
        v-if="loadingSuggestions"
        class="tw-ml-2 sf-spinner tw-border-sf-ai"
      />
      <SfIndicatorCount v-else ai data-test-id="assistant-suggestions-count">
        {{ suggestionCount }}
      </SfIndicatorCount>
    </SfButtonInverted>
  </header>
</template>

<script setup lang="ts">
import SfButtonInverted from '../../../../../shared/vue/components/sf-button/sf-button-inverted.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import NewRemarkButton from '@app/shared/vue/components/new-remark/new-remark-button.vue'
import { useAssistantSuggestionsStore } from '@app/application/client_meetings/screens/preparation/store/assistant-suggestions'
import { storeToRefs } from 'pinia'
import { SfIndicatorCount } from '@app/shared/vue/components/sf-indicator'

interface Props {
  empty: boolean
  suggestionsEnabled: boolean
  showSidebar: boolean
  talkingPointTagId?: number
  ledgerId: number
  ledgerLabel: string
}

defineProps<Props>()

const I18n = useI18n()

const ownerId = window.Silverfin.currentCompanyId

const emit =
  defineEmits<{
    toggleSidebar: []
    completeMeeting: []
  }>()

function toggleSidebar() {
  emit('toggleSidebar')
}

function completeMeeting() {
  emit('completeMeeting')
}

const assistantSuggestionsStore = useAssistantSuggestionsStore()

const { suggestionCount, loadingSuggestions } = storeToRefs(
  assistantSuggestionsStore
)
</script>
